<template>
  <modal
    title="Wallet"
    width="35"
    :showModal="showModal"
    @close-modal="$emit('closeModal')"
  >
    <div>
      <div class="mt-3">
        <label>Name</label>
        <input v-model="wallet.user" placeholder="--Auto Filled--" class="bg-gray-200 p-2 w-full" />
      </div>

      <div class="mt-3">
        <label>Wallet ID </label>
        <input v-model="wallet.walletId" placeholder="--Autogenerated--" class="bg-gray-200 p-2 w-full" />
      </div>

      <div class="mt-3 ">
        <label class="flex items-center justify-between"
          ><abbr>Wallet Balance</abbr>
          <span class="flex items-center text-primary-yellow"
            ><img src="@/assets/images/wallet/top_up.svg" class="mr-1 w-6" />Top Up</span
          ></label
        >
        <div class="flex items-center border_1 border-gray-200 rounded-md">
          <div class="w-24">
            <el-select v-model="wallet.currency" placeholder="Select country">
              <el-option v-for="currency in currencies" :key="currency" :label="currency" :value="currency">
              </el-option>
            </el-select>
          </div>
          <input placeholder="0.00" type="number" class="bg-white p-2 w-full" />
        </div>
      </div>

      <div class="flex justify-end mt-48">
        <button @click="$emit('closeModal')">Cancel</button>

        <button @click="createWallet" class="w-24 bg-primary-yellow py-2 text-center ml-4 rounded-md">
          Save
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      currencies: ['NGN'],
      wallet : {
        currency: "NGN",
        user: "",
        walletId: ""
      }
    }
  },
  computed: {
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("loggedInUser"))
      this.wallet.user = `${user.firstname}  ${user.lastname}`;
      this.wallet.walletId = this.reference
  },
  methods: {
    async createWallet() {
      try {
        await this.$_createWallet({
          userId: localStorage.getItem("userId"),
        });
        this.$router.push("/settings/wallet-details");
        this.$emit('closeModal')
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.input {
  @apply w-12 h-12 text-primary-black border-2 border-gray-300 flex text-center items-center rounded-md mx-2;
}
.el-select{
  margin-bottom: 0
}
.border_1{
  border-width: 1px;

}
</style>
